// import external dependencies
import 'jquery';

// import everything from autoload
import './autoload/_bootstrap.js';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import templatePortalAccount from './routes/template-portal-account';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All modules
  common,
  // Portal Account
  templatePortalAccount,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js